import React, { Component } from 'react'
import style from './style.css'

class Font extends Component {

    render() {
        if(this.props.heading) {
            switch(this.props.heading) {
                case '1':
                    return(
                        <h1
                            {...this.props}
                            className={`${style.heading} ${this.props.className || ''}`}                            
                            style={{
                                ...this.props.style,
                                color: `${this.props.color || ''}`,
                                fontWeight: this.props.weight || null,
                                fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : null}`,
                                ...this.props.style,
                            }}
                        >
                            {this.props.children}
                        </h1>
                    )
                case '2':
                    return(
                        <h2
                            {...this.props}
                            className={`${style.heading} ${this.props.className || ''}`}                            
                            style={{
                                ...this.props.style,
                                color: `${this.props.color || ''}`,
                                fontWeight: this.props.weight || null,
                                fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : null}`,
                                ...this.props.style,
                                }}
                        >
                            {this.props.children}
                        </h2>
                    )
                case '3':
                    return(
                        <h3
                            {...this.props}
                            className={`${style.heading} ${this.props.className || ''}`}
                            style={{
                                ...this.props.style,
                                color: `${this.props.color || ''}`,
                                fontWeight: this.props.weight || null,
                                fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : null}`,
                                ...this.props.style,
                                }}
                        >
                            {this.props.children}
                        </h3>
                    )
                case '4':
                    return(
                        <h4
                            {...this.props}
                            className={`${style.heading} ${this.props.className || ''}`}                            
                            style={{
                                ...this.props.style,
                                color: `${this.props.color || ''}`,
                                fontWeight: this.props.weight || null,  
                                fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : null}`,      
                                ...this.props.style,                        
                                }}
                        >
                            {this.props.children}
                        </h4>
                    )
                case '5':
                    return(
                        <h5
                            {...this.props}
                            className={`${style.heading} ${this.props.className || ''}`}                            
                            style={{
                                ...this.props.style,
                                color: `${this.props.color || ''}`,
                                fontWeight: this.props.weight || null,
                                fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : null}`,
                                ...this.props.style,               
                                }}
                        >
                            {this.props.children}
                        </h5>
                    )
                default:
                    return
            }
        }

        return (
            <font
                {...this.props}
                className={`${style.font} ${this.props.className || ''}`}
                style={{
                        color: `${this.props.color || ''}`,
                        fontSize: `${(this.props.size) ? parseInt(this.props.size, 10)/10+'em' : '1.4em'}`,
                        fontWeight: this.props.weight || null,
                        textTransform: (this.props.upper) ? 'uppercase' : 'initial',
                        fontStyle: (this.props.italic) ? 'italic' : '',
                        ...this.props.style,
                    }}
            >
                {this.props.children}
            </font>
        )
    }
}

export default Font


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Font/index.js